<template>
  <Drawer
    class="drawer_modal"
    width="1000"
    v-model="showDrawer"
  >

    <Row type="flex" justify="end">
      <Dropdown style="margin: -10px 0 -5px 15px;" @on-click="fetchDocTemplate">
        <!--<Tooltip content="Скачать документы" placement="right">-->
        <Button type="info"><Icon type="md-download" /> Документы</Button>
        <!--</Tooltip>-->
        <DropdownMenu slot="list" style="padding: 15px">
          <DropdownItem v-for="item in doc_templates" :name="item.type" :key="item.name" class="fs-15 card-container" align="center" style="padding: 15px 20px; margin-bottom: 12px">
            <!--<a :href="fetchPdfUrl">-->
            <span class="fs-14">{{ item.name }}</span>

            <!--</a>-->
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Row>

    <productOrderDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></productOrderDetail>

    <productOrderForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></productOrderForm>
  </Drawer>
</template>

<script>
import { base_url } from "../../http.js";
import productOrderForm from "@/apps/product_order/productOrderForm.vue";
import productOrderDetail from "@/apps/product_order/productOrderDetail.vue";

export default {
  name: "productOrderItem",
  components: {
    productOrderDetail,
    productOrderForm
  },
  model: {
    prop: "show_drawer",
    event: "change"
  },
  props: {
    id: [Number, String],
    action: String,
    show_drawer: Boolean,
    base_view_url: String,
    item_type: String
  },
  data() {
    return {
      titles: {
        detail: "Документ",
        edit: "Редактирование документа",
        create: "Создание документа"
      },
      itemAction: "detail",
      itemId: "",
      showDrawer: false,
      doc_templates: []
      // fetchPdfUrl: base_url + "/product_order/pdf/"
    };
  },
  computed: {
    title() {
      return this.titles[this.itemAction];
    },
    showDetailComponent() {
      return this.showDrawer && this.itemAction === "detail";
    },
    showFormComponent() {
      return (
        this.showDrawer &&
        (this.itemAction === "edit" || this.itemAction === "create")
      );
    },

    doc_templates_obj() {
      let obj = {};

      this.doc_templates.forEach((val, index)=>{
        obj[val.type] = val.name;
      });
      return obj;
    }
  },
  methods: {
    // Common actions
    showDetail(id) {
      this.itemAction = "detail";
      this.$router.push({
        name: this.item_type + "_detail",
        params: { id: id }
      });
    },
    showEdit(id) {
      this.itemAction = "edit";
      this.$router.push({ name: this.item_type + "_edit", params: { id: id } });
    },
    showCreate() {
      this.itemAction = "create";
      this.$router.push({ name: this.item_type + "_create" });
    },

    // User actions
    cancelAction() {
      this.showDrawer = false;
    },
    editAction(id) {
      this.showEdit(id);
    },

    fetchListDocTemplates() {
      const url = `${base_url}/product_orders/${this.id}/templates/`;
      this.$http
        .get(url)
        .then(result => {
          this.doc_templates = [];
          result.data.forEach(value => {
            this.doc_templates.push(value);
          });
        })
        .catch(error => {
          this.$Message.error("Произошла ошибка. Попробуйте позже.");
          console.log(error);
        });
    },

    fetchDocTemplate(type) {
      // window.onbeforeunload = function () {};
      //
      // location.href = base_url + "/product_order/pdf/";
      //
      // window.onbeforeunload = function () {
      //   return "Вы уверены, что хотите закрыть приложение?";
      // };

      const url = `${base_url}/product_orders/${this.id}/pdf/?template_type=${type}`;
      this.$http({
        url: url,
        method: "GET",
        responseType: "blob" // important
      })
        .then(response => {
          const blob = new Blob([response.data], { type: "application/pdf" });

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          // console.log(response);
          // let headerLine = response.headers['content-disposition'];
          // let startFileNameIndex = headerLine.indexOf('"') + 1;
          // let endFileNameIndex = headerLine.lastIndexOf('"');
          // let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);

          a.download = `${this.doc_templates_obj[type]}.pdf`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          this.$Message.error("Произошла ошибка. Попробуйте позже.");
          console.log(error);
        });
    }
  },
  watch: {
    show_drawer: function(newValue, oldValue) {
      this.showDrawer = newValue;
      this.itemAction = this.action;
      this.itemId = this.id;

      if (newValue) {
        if (this.itemAction === "detail") {
          this.showDetail(this.itemId);

          this.fetchListDocTemplates();
        } else if (this.itemAction === "edit") {
          this.showEdit(this.itemId);
        } else if (this.itemAction === "create") {
          this.showCreate();
        }
      } else {
        this.detail = {};
        this.formData = {};
        //this.$router.go(-1);
        this.$router.push({ name: this.item_type });
      }
    },
    showDrawer: function(newValue, oldValue) {
      this.$emit("change", newValue);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/product_order/productOrderItem.vue